// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"140":"8ff8e19b","375":"c6855647","382":"97db2e30","822":"48d87ba3"}[chunkId] + ".css";
};